import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Subscription, SubscriptionUIModel } from '../../../features/payment/types/subscription';
import { RootState } from '..';
import { MemberSubscription } from '../../types/user';

export interface  SubscriptionPayment {
  subscription: MemberSubscription;
  paymentStatus: string;
}

export interface SubscriptionState {
  subscriptions: Subscription[];
  transformedSubscriptions: SubscriptionUIModel[];
  selectedSubscription?: SubscriptionUIModel;
  subscriptionPayment?: SubscriptionPayment
}

const initialState: SubscriptionState = {
  subscriptions: [],
  transformedSubscriptions: [],
  selectedSubscription: undefined,
  subscriptionPayment: undefined,
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptions: (state, action: PayloadAction<Subscription[]>) => {
      state.subscriptions = action.payload;
    },
    setSubscriptionsUiModel: (state, action: PayloadAction<SubscriptionUIModel[]>) => {
      state.transformedSubscriptions = action.payload;
    },
    setSelectedSubscription: (state, action: PayloadAction<SubscriptionUIModel>) => {
      state.selectedSubscription = action.payload;
    },
    setSubscriptionPayment: (state, action: PayloadAction<any>) => {
      state.subscriptionPayment = action.payload;
    },
  },
});

export const getSelectedSubscription = (state: RootState) => state.subscription.selectedSubscription;
export const getSubscriptionPayment = (state: RootState) => state.subscription.subscriptionPayment;

export const { setSubscriptions, setSubscriptionsUiModel, setSelectedSubscription, setSubscriptionPayment } =
  subscriptionSlice.actions;

export default subscriptionSlice.reducer;
